module.exports = __webpack_public_path__ + "static/media/health10.ec6bb9b6.svg";